



































































































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import Combobox from '../../core/components/Combobox.vue';
import { MsgBox, PlusEyeButtons, Breadcrums, CloseConfirmationModal } from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import { farmingTypeOptions } from '../../insurance/helpers';
import { InsuranceServices } from '../../insurance/api/InsuranceServices';

@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        PlusEyeButtons,
        Breadcrums,
        CloseConfirmationModal
    }
})
export default class DownloadFileExtension extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({
        default() {
            return [];
        }
    })
    ranchsIds: string[];
    @Prop({
        default() {
            return [];
        }
    })
    extensionOptions: Array<object>;
    @Prop({ default: false }) visible: boolean;
    @Prop({ default: '' }) defaultName: string;
    @Prop({ default: 'Descargar archivo' }) modalTitle: string;
    @Prop({default: 0}) farmingType: number;
    pdfOptions: Array<object> = [];
    visibleModal: boolean = false;
    pendingRequest: boolean = false;
    description: string = '';
    downloadBtn: string = 'Descargar archivo';
    includePublicNotes: boolean = true;

    //select options
    extensionSelected: any | null = null;
    pdfVersionSelected: any | null = null;

    //select reset value
    extensionRV: boolean = false;
    pdfVersionRv: boolean = false;

    msgLoadingDialog: string = '';
    errorResponse: any = {};
    successPost: boolean | null = null;

    get isSowing() {
        return this.farmingType === farmingTypeOptions.sowing;
    }

    get formatIsPdf() {
        return this.extensionSelected !== null && this.extensionSelected['value'] === 'PDF' ? true : false;
    }


    getPdfOptions(){
        this.pdfOptions = [];
        InsuranceServices.getPdfVersions(this.farmingType).then((response) => {
            this.pdfOptions = response;
            this.updatePdfVersionSelected(this.pdfOptions[0]);
        }).catch((error) => {
            
            this.$_catchLoadingDialog({
                error: error,
                msg: 'Error al obtener las versiones de pdf'
            })
        });
    }

    @Watch('description')
    observableDescription(value) {
        if (value == null) {
            this.description = '';
        }
    }

    @Emit()
    downloadFile(fileName: string, extensionSelected: string, includePublicNotes: boolean, versionSelected:object | null) {}

    //methods
    mounted() {
        this.getPdfOptions();
        this.handleListenKey(true);
        this.description = this.defaultName;
        this.visibleModal = this.visible;
    }

    matchedIndexInArray(arr, id) {
        let optionIndex = arr.findIndex(item => item['id'] == id);
        return optionIndex;
    }

    updateExtensionSelected(option) {
        if (this.description === '') {
            this.description = option['defaultName'];
        }
        this.extensionSelected = option;
    }

    @Watch('pdfVersionSelected', { deep: true })
    onPdfVersionSelectedChange(value) {
        let self = this;
        if (value == null) {
            setTimeout(() => {
                self.pdfVersionSelected = self.pdfOptions[0];
            }, 0);
            
        }
    }

    updatePdfVersionSelected(option) {
        this.pdfVersionSelected = option;
    }

    updatePdfVersionSelectedRv(value) {
        this.pdfVersionRv = value;
    }

    updateExtensionResetValue(value) {
        this.extensionRV = value;
    }

    closeModal() {
        this.$emit('close-modal', false);
        this.handleListenKey(false);
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    triggerSubmit() {
        this.downloadFile(this.description, this.extensionSelected['value'], this.includePublicNotes, this.pdfVersionSelected);
        this.closeModal();
    }

    clearScrollLoadingDialog() {
        $('html').css('overflow-y', 'hidden');
        $('.dialog-slot').css('overflow-y', 'hidden');
    }

    scrollToTopOfModal() {
        $('.dialog-slot').scrollTop(0);
    }


    getData() {
        // return {
        //     "ranch_ids": this.ranchsIds,
        //     "name": this.description,
        //     "harvest_type": Number(this.cropTypeSelected['id'])
        // }
    }

    get canShowIncludeBoolean() {
        return this.extensionSelected !== null && this.extensionSelected['value'] === 'PDF' ? true : false;
    }

    get checkIfFormIsValid() {
        if (this.description === '') {
            return false;
        }

        if (this.extensionSelected == null) {
            return false;
        }

        return true;
    }

    enableScrollLoadingDialog() {
        $('.dialog-slot').css('overflow-y', 'auto');
        $('html').css('overflow-y', 'auto');
    }

    closeModalLoadingDialog() {
        this.pendingRequest = false;
        this.successPost = null;
        this.msgLoadingDialog = '';
        this.enableScrollLoadingDialog();
    }
}
